import { ReactNode } from "react";

export const TableEmptyState = ({
  icon,
  title,
  description,
}: {
  icon: ReactNode;
  title?: string;
  description?: string;
}) => {
  return (
    <div className="t-flex t-flex-col t-gap-2 t-items-center t-m-auto">
      <div className="t-w-[42px] t-h-[42px] t-bg-surface-lighter-grey t-rounded-full t-flex t-items-center t-justify-center t-border t-border-solid t-border-neutral-0">
        {icon}
      </div>
      <div className="t-flex t-flex-col t-items-center t-gap-1 t-text-text-30">
        <div className="t-text-subtext">{title || ""}</div>
        <div className="t-text-caption">{description || ""}</div>
      </div>
    </div>
  );
};
